import { Component } from '@angular/core';
import { NavigService } from 'src/app/services/navig.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent {
constructor(
  public nav : NavigService
){}

}
